module.exports = __webpack_public_path__ + "img/sld_acdb_panel_dark.c334d0f8.svg";